<footer class="footer section-inset-y">
  <h2 class="sr-only">Footer</h2>

  <div class="container">
    @if (menu(); as menu) {
      <div class="row">
        @for (item of menu | ofMenuType: 'MenuItem'; track item) {
          <nav class="mb-4 col-xsm-12 col-lg-6 footer__nav">
            <h3 class="footer__nav__title mb-3 mb-lg-4 text-primary">{{ item.title }}</h3>

            @if (item.label === 'locations') {
              @if (centralLocation$(); as location) {
                <ul class="footer__nav__list">
                  @for (department of location.departments; track department) {
                    @if (!department.hideOpeningTimes) {
                      <li class="mb-2 mb-md-3">
                        <strong class="d-block">{{ department.name }}</strong>
                        <em>{{ getOpeningTime(department) }}</em>
                      </li>
                    }
                  }
                </ul>
              }
              <app-json-ld [json]="schema()" />
            }
            <ul class="footer__nav__list">
              @for (link of item.menuItems | ofMenuType: 'MenuItem'; track link) {
                <li class="mb-2 mb-md-3">
                  <fstr-link [button]="buttonLink(link)" [cssClasses]="'button button-link button--dark'" />
                </li>
              }
            </ul>
          </nav>
        }
      </div>
    }

    <section class="footer__end-nav d-flex flex-wrap mt-5 gap-3 justify-content-start justify-content-lg-between">
      @if (menuMain(); as menuMain) {
        <nav class="">
          <ul class="footer__nav-list d-flex gap-3 flex-wrap">
            @for (link of menuMain; track link) {
              <li>
                <fstr-link [button]="{
                    text: link.title,
                    url: link.url || '',
                    routerLink: link.routerLink,
                    fragment: link.fragment,
                    queryParams: link.queryParams,
                  }"
                  [cssClasses]="'button button-link button--dark'"
                 />
              </li>
            }
          </ul>
        </nav>
      }
      @if (menuEnd(); as menuEnd) {
        <nav class="">
          <ul class="footer__nav-list d-flex gap-3 flex-wrap">
            @for (link of menuEnd; track link) {
              <li>
                <fstr-link [button]="{
                    text: link.title,
                    url: link.url || '',
                    routerLink: link.routerLink,
                    fragment: link.fragment,
                    queryParams: link.queryParams,
                  }"
                  [cssClasses]="'button button-link button--dark'"
                 />
              </li>
            }
            <li class="footer__nav-list__item">
              <button (click)="openCookie()" class="button button-link button--dark">{{ 'cookie-settings' | fromDictionary }}</button>
            </li>
          </ul>
        </nav>
      }
    </section>
  </div>
</footer>
